import { ApiService } from './api';
import {
  DeliveryPolygon,
  CreateDeliveryPolygonRequest,
  UpdateDeliveryPolygonRequest,
  FindPolygonResponse,
  UpdatePolygonsPriorityRequest,
} from '../types/deliveryPolygons';

class DeliveryPolygonsService {
  private apiService: ApiService;

  constructor() {
    this.apiService = ApiService.getInstance();
  }

  async getAllPolygons() {
    try {
      const polygons = await this.apiService.get<DeliveryPolygon[]>('/admin/delivery-polygons');
      return { success: true, data: polygons, error: null };
    } catch (error: any) {
      return { success: false, data: null, error: error.message || 'Failed to fetch delivery polygons' };
    }
  }

  async createPolygon(request: CreateDeliveryPolygonRequest) {
    try {
      const polygon = await this.apiService.post<DeliveryPolygon>('/admin/delivery-polygons', request);
      return { success: true, data: polygon, error: null };
    } catch (error: any) {
      return { success: false, data: null, error: error.message || 'Failed to create delivery polygon' };
    }
  }

  async updatePolygon(request: UpdateDeliveryPolygonRequest) {
    try {
      const polygon = await this.apiService.put<DeliveryPolygon>('/admin/delivery-polygons', request);
      return { success: true, data: polygon, error: null };
    } catch (error: any) {
      return { success: false, data: null, error: error.message || 'Failed to update delivery polygon' };
    }
  }

  async deletePolygon(polygonId: number) {
    try {
      await this.apiService.delete(`/admin/delivery-polygons/${polygonId}`);
      return { success: true, error: null };
    } catch (error: any) {
      return { success: false, error: error.message || 'Failed to delete delivery polygon' };
    }
  }

  async findPolygonByCoordinates(lat: number, lng: number) {
    try {
      const response = await this.apiService.get<DeliveryPolygon>(`/admin/delivery-polygons/find?lat=${lat}&lng=${lng}`);
      return { success: true, data: response, error: null };
    } catch (error: any) {
      return { success: false, data: null, error: error.message || 'No polygon found for this location' };
    }
  }

  async updatePolygonsPriority(request: UpdatePolygonsPriorityRequest) {
    try {
      await this.apiService.patch('/admin/delivery-polygons/priority', request);
      return { success: true, error: null };
    } catch (error: any) {
      return { success: false, error: error.message || 'Failed to update polygon priorities' };
    }
  }
}

export const deliveryPolygonsService = new DeliveryPolygonsService();
